import script from "./dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./dashboard.vue?vue&type=script&setup=true&lang=js"

import "./dashboard.vue?vue&type=style&index=0&id=f57c951a&lang=scss&scoped=true"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f57c951a"]])

export default __exports__